import * as amplitude from '@amplitude/analytics-browser';
import {
  beginGoogleAdsQuizJourney,
  trackGoogleAdsEvent,
  trackGoogleAdsQuizComplete,
} from './GoogleAdsFunnelEvents';
import { trackGoogleAnalyticsEvent } from './GoogleAnalyticsEvents';

const trackAnalyticsEvent = (eventName, properties = {}) => {
  try {
    amplitude.track(eventName, properties);
  } catch {
    // Analytics must never interrupt quiz, registration, or payment flows.
  }
  trackGoogleAnalyticsEvent(eventName, properties);
  trackGoogleAdsEvent(eventName, properties);
};

// 1. Пользователь открыл страницу (onboarding started)
const ampOnboardingStarted = () => {
  trackAnalyticsEvent('onboarding started');
};

// 2. Пользователь выбрал пол
const ampGenderSelected = (gender) => {
  beginGoogleAdsQuizJourney();
  trackAnalyticsEvent('gender_selected', { gender });
};

// 3. Пользователь попал на 2 экран
const amp2ndScreen = () => {
  trackAnalyticsEvent('2nd screen');
};

// 4. Пользователь выбрал возраст
const ampAgeSelected = (age) => {
  trackAnalyticsEvent('age_selected', { age });
};

// 5. Пользователь завершил экран
const ampScreenCompleted = (screen_id, title=null, input=null) => {
  trackAnalyticsEvent('screen completed', {
    screen_id,
    title,
    input,
  });
};

// 6. Пользователь оставил email
const ampRegistration = () => {
  trackAnalyticsEvent('registration');
};

// 7. Пользователь попал на страницу пейвола
const ampPaywall = (paywall_id) => {
  trackAnalyticsEvent('paywall', { paywall_id });
  if (paywall_id === 'paywall') {
    trackGoogleAdsQuizComplete();
  }
};

// 8. Пользователь открыл попап с другими способами оплаты (не Apple Pay)
const ampCheckoutView = (plan, price, currency) => {
  trackAnalyticsEvent('checkout view', {
    plan,
    price,
    currency,
  });
};

// 9. Пользователь кликнул по кнопке PayPal
const ampPaypalButtonClicked = (plan, price, currency, country) => {
  trackAnalyticsEvent('paypal_button_clicked', {
    plan,
    price,
    currency,
    country,
  });
};

// 10. Пользователь кликнул по кнопке Apple Pay
const ampApplePayUiOpened = (plan, price, currency) => {
  trackAnalyticsEvent('apple_pay_ui_opened', {
    plan,
    price,
    currency,
  });
};

// 11. Пользователь оплатил подписку (браузерный Event)
const ampPurchase = ({currency, payment_method, price, productId, quantity}) => {
  trackAnalyticsEvent('purchase', {
    currency,
    payment_method,
    price,
    productId,
    quantity,
  });
};

// 12. Пользователь зарегистрировался в приложении
const ampAppRegistration = (userId, email) => {
  trackAnalyticsEvent('App registration', {
    userId,
    email,
  });
  amplitude.setUserId(userId);
};

// 13. Пользователь оплатил Upsale услугу
const ampPurchaseAdditional = ({currency, payment_method, price, productId, quantity}) => {
  trackAnalyticsEvent('purchaseAditional', {
    currency,
    payment_method,
    price,
    productId,
    quantity,
  });
};

// 14. Пользователь перешел в стор для скачивания прилы
const ampAppDownloadClick = () => {
  trackAnalyticsEvent('app download click');
};


// 14. Puschase статусы
const ampPurchaseStatus = (status, message="")=>{
  switch (status) {
    case 'started':
      trackAnalyticsEvent('Purchase Started');
      break;
    case 'decline':
      trackAnalyticsEvent('purchase failed', {
        "type": message
      });
      trackAnalyticsEvent('Purchase Decline',{
          "type" : message
        } 
      );
      break;
    case 'complete':
      trackAnalyticsEvent('Purchase Complete');
      break;
    case 'UpsaleStarted':
      trackAnalyticsEvent('Upsale Purchase Started');
      break;
    case 'UpsaleDecline':
      trackAnalyticsEvent('Upsale Purchase Decline',{
          "type" : message
        } 
      );
      break;
    case 'UpsaleComplete':
      trackAnalyticsEvent('Upsale Purchase Complete');
      break;
  }
  
}


export {
  ampPurchaseStatus,
  ampOnboardingStarted,
  ampGenderSelected,
  amp2ndScreen,
  ampAgeSelected,
  ampScreenCompleted,
  ampRegistration,
  ampPaywall,
  ampCheckoutView,
  ampPaypalButtonClicked,
  ampApplePayUiOpened,
  ampPurchase,
  ampAppRegistration,
  ampPurchaseAdditional,
  ampAppDownloadClick
}
